/**
 * Apparition au défilement.
 *
 * Les éléments visibles dès le chargement sont déjà révélés par le script
 * inline de inc/assets.php, qui leur pose `is-instant` : ce module ne s'occupe
 * que de ceux qui entrent dans la fenêtre ensuite, et ne les masque jamais à
 * nouveau — sans quoi le texte du hero clignoterait au premier défilement.
 */
export function initScrollAnimations() {
    const elements = document.querySelectorAll('.scroll-animate');
    if (elements.length === 0) return;

    // Sécurité : si l'IntersectionObserver manque, tout est révélé d'un coup
    // plutôt que de rester invisible.
    if (typeof IntersectionObserver === 'undefined') {
        elements.forEach((el) => el.classList.add('is-visible', 'is-instant'));
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                } else if (!entry.target.classList.contains('is-instant')) {
                    // Rejoue l'animation au retour dans la fenêtre, sauf pour
                    // les éléments révélés d'emblée au chargement.
                    entry.target.classList.remove('is-visible');
                }
            });
        },
        { threshold: 0.2 }
    );

    elements.forEach((element) => observer.observe(element));
}
